// Core Imports
import GraniteError from 'granite-admin/utils/granite-error';
import GraniteAPIClient from 'granite-admin/utils/granite-client';
import LogicalEntity from '../entities/permissionGrpMgt';
const url = process.env.REACT_APP_ORGANISATION_BASE_URL;
async function getLogicalPermission(params) {
  const payload = {
    params: {
      ...params
    }
  };
  try {
    const {
      data
    } = await GraniteAPIClient(url).get('/permission_group/', payload);
    const list = data ? data.results.map(item => new LogicalEntity(item)) : [];
    return {
      list,
      count: data.count
    };
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function createLogicalPermission(params) {
  const payload = new LogicalEntity(params).mapToSnakeCase();
  try {
    const {
      data
    } = await GraniteAPIClient(url).post('/permission_group/', payload);
    return new LogicalEntity(data);
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function updateLogicalPermission(params) {
  const payload = new LogicalEntity(params).mapToSnakeCase();
  const {
    pk
  } = payload;
  try {
    const {
      data
    } = await GraniteAPIClient(url).put(`/permission_group/${pk}/`, payload);
    return new LogicalEntity(data);
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function deleteLogicalPermission(pk) {
  try {
    const {
      data
    } = await GraniteAPIClient(url).delete(`/permission_group/${pk}/`);
    return data;
  } catch (error) {
    throw new GraniteError(error);
  }
}
export default {
  getLogicalPermission,
  createLogicalPermission,
  updateLogicalPermission,
  deleteLogicalPermission
};